import React from "react";
import { Link } from "react-router-dom";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  Button,
  UncontrolledCollapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
  Row,
  Col, NavLink
} from "reactstrap";

class DemoNavbar extends React.Component {
  componentDidMount() {
    let headroom = new Headroom(document.getElementById("navbar-main"));
    // initialise
    headroom.init();
  }
  state = {
    collapseClasses: "",
    collapseOpen: false,
  };

  urlLoginBack = process.env.REACT_APP_API_URL_SERVER_LOGIN_BACK;
  onExiting = () => {
    this.setState({
      collapseClasses: "collapsing-out",
    });
  };

  onExited = () => {
    this.setState({
      collapseClasses: "",
    });
  };

  render() {
    return (
      <>
        <header className="header-global">
          <Navbar
            className="navbar-main navbar-transparent navbar-light headroom"
            expand="lg"
            id="navbar-main"
          >
            <Container>
              <NavbarBrand className="mr-lg-5" to="/" tag={Link}>
                <img
                  alt="..."
                  src={require("assets/img/logo/linear_inverse.png")}
                />
              </NavbarBrand>
              <button className="navbar-toggler" id="navbar_global">
                <span className="navbar-toggler-icon" />
              </button>
              <UncontrolledCollapse
                toggler="#navbar_global"
                navbar
                className={this.state.collapseClasses}
                onExiting={this.onExiting}
                onExited={this.onExited}
              >
                <div className="navbar-collapse-header">
                  <Row>
                    <Col className="collapse-brand" xs="6">
                      <Link to="/">
                        <img
                          alt="logo"
                          src={require("assets/img/logo/linear_default.png")}
                          width={275}
                        />
                      </Link>
                    </Col>
                    <Col className="collapse-close" xs="6">
                      <button className="navbar-toggler" id="navbar_global">
                        <span />
                        <span />
                      </button>
                    </Col>
                  </Row>
                </div>
                <Nav className="navbar-nav-hover align-items-lg-center" navbar>
                  <NavItem className=" d-lg-block ml-lg-4">
                    <NavLink
                        aria-expanded={false}
                        aria-haspopup={true}
                        data-toggle="dropdown"
                        href="/suscripciones"
                        id="navbar-primary_dropdown_1"
                        role="button"
                    >
                      Suscripciones
                    </NavLink>
                  </NavItem>
                  <NavItem className=" d-lg-block ml-lg-4">
                    <NavLink
                        aria-expanded={false}
                        aria-haspopup={true}
                        data-toggle="dropdown"
                        href="/faqs"
                        id="navbar-primary_dropdown_1"
                        role="button"
                    >
                      Faqs
                    </NavLink>
                  </NavItem>
                  <NavItem className=" d-lg-block ml-lg-4">
                    <NavLink
                        aria-expanded={false}
                        aria-haspopup={true}
                        data-toggle="dropdown"
                        href="/documentacion"
                        id="navbar-primary_dropdown_1"
                        role="button"
                    >
                      Documentación
                    </NavLink>
                  </NavItem>
                </Nav>
                <Nav className="align-items-lg-center ml-lg-auto" navbar>
                  <NavItem className=" d-lg-block ml-lg-4">
                    <Button
                      className="btn-neutral btn-icon"
                      color="default"
                      href={this.urlLoginBack}
                    >
                      <span className="btn-inner--icon">
                        <i className="fa fa-user-circle-o mr-2" />
                      </span>
                      <span className="nav-link-inner--text ml-1">
                        Iniciar session
                      </span>
                    </Button>
                  </NavItem>
                </Nav>
              </UncontrolledCollapse>
            </Container>
          </Navbar>
        </header>
      </>
    );
  }
}

export default DemoNavbar;
